import { Component, inject } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { DrawerModule } from 'primeng/drawer';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { LayoutService } from '@core/diamond/service/layout.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: '[app-rightmenu]',
  standalone: true,
  imports: [DrawerModule, DividerModule, SelectModule, InputTextModule, FormsModule, ButtonModule],
  template: ` <p-drawer
    header="Menu"
    [(visible)]="rightMenuVisible"
    position="right"
    styleClass="layout-rightmenu w-full! sm:w-xl!"
  >
    <div>
      <h2 class="title-h7 text-left">Activity</h2>
      <div class="flex flex-col mt-7">
        <div class="flex gap-6">
          <div class="flex flex-col items-center">
            <span
              class="w-14 h-14 flex items-center justify-center border border-surface rounded-xl shadow-[0px_1px_2px_0px_rgba(18,18,23,0.05);]"
            >
              <i class="pi pi-dollar text-blue-600 text-2xl!"></i>
            </span>
            <span class="min-h-14 w-px bg-(--surface-border)"></span>
          </div>
          <div class="mt-2">
            <h5 class="label-large">New Sale</h5>
            <p class="md:label-small mt-1">
              Richard Jones has purchased a blue t-shirt for
              <b class="body-small text-surface-950 dark:text-surface-0">$79</b>
            </p>
          </div>
        </div>
        <div class="flex gap-6">
          <div class="flex flex-col items-center">
            <span
              class="w-14 h-14 flex items-center justify-center border border-surface rounded-xl shadow-[0px_1px_2px_0px_rgba(18,18,23,0.05);]"
            >
              <i class="pi pi-download text-orange-600 text-2xl!"></i>
            </span>
            <span class="min-h-14 w-px bg-(--surface-border)"></span>
          </div>
          <div class="mt-2">
            <h5 class="label-large">Withdrawal Initiated</h5>
            <p class="md:label-small mt-1">
              Your request for withdrawal of
              <b class="body-small text-surface-950 dark:text-surface-0">$2500</b> has been
              initiated.
            </p>
          </div>
        </div>
        <div class="flex gap-6">
          <div class="flex flex-col items-center">
            <span
              class="w-14 h-14 flex items-center justify-center border border-surface rounded-xl shadow-[0px_1px_2px_0px_rgba(18,18,23,0.05);]"
            >
              <i class="pi pi-question-circle text-violet-600 text-2xl!"></i>
            </span>
            <span class="min-h-14 w-px bg-(--surface-border)"></span>
          </div>
          <div class="mt-2">
            <h5 class="label-large">Question Received</h5>
            <p class="md:label-small mt-1">
              Jane Davis has posted a
              <b class="body-small text-surface-950 dark:text-surface-0">new question</b> about your
              product.
            </p>
          </div>
        </div>
        <div class="flex gap-6">
          <div class="flex flex-col items-center">
            <span
              class="w-14 h-14 flex items-center justify-center border border-surface rounded-xl shadow-[0px_1px_2px_0px_rgba(18,18,23,0.05);]"
            >
              <i class="pi pi-comment text-blue-600 text-2xl!"></i>
            </span>
          </div>
          <div class="mt-2">
            <h5 class="label-large">Comment Received</h5>
            <p class="md:label-small mt-1">
              Claire Smith has upvoted your store along with a
              <b class="body-small text-surface-950 dark:text-surface-0">comment.</b>
            </p>
          </div>
        </div>
      </div>
    </div>
    <p-divider class="my-10!" />
    <div>
      <h2 class="title-h7 text-left">Quick Withdraw</h2>
      <div class="flex flex-col gap-3.5 mt-7 mb-6">
        <input pInputText type="text" [(ngModel)]="amountValue" placeholder="Amount" />
        <p-select
          [(ngModel)]="selectedCard"
          [options]="cards"
          optionLabel="label"
          placeholder="Select a Card"
          class="w-full"
        />
      </div>
      <p-button label="Confirm" severity="success" class="w-full!"></p-button>
    </div>
    <p-divider class="my-10!" />
    <div>
      <h2 class="title-h7 text-left">Shipment Tracking</h2>
      <p class="body-small mt-1 text-left">Track your ongoing shipments to customers.</p>
      <img
        class="w-full h-full max-h-60 object-cover border border-surface rounded-2xl mt-4"
        src="/layout/images/sidebar-right/staticmap.png"
        alt="diamond-vue"
      />
    </div>
  </p-drawer>`,
})
export class AppRightMenu {
  layoutService: LayoutService = inject(LayoutService);

  cards = [
    { label: '*****24', value: { id: 1, name: '*****24', code: 'A1' } },
    { label: '*****75', value: { id: 2, name: '*****75', code: 'A2' } },
  ];

  selectedCard: any;
  amountValue: string = '';

  get rightMenuVisible(): boolean {
    return this.layoutService.layoutState().rightMenuVisible;
  }

  set rightMenuVisible(_val: boolean) {
    this.layoutService.layoutState.update((prev) => ({ ...prev, rightMenuVisible: _val }));
  }
}
